import './images/header.png';
import './images/red_header.png';
import './index.erb';
import './index.rb';
import CookieManager from 'utils/cookie_manager';
import ModalManager from 'utils/modal_manager';

class SubscriptionExpirationModal {
  constructor() {
    this.$context = $('#js-time-box-modal');
    this.cookieName = 'renewal_timebox';

    if (!this.$context.length) {
      return false;
    }

    this.bind();
  }

  bind() {
    const isModalHidden = !this.$context.hasClass('open');
    const hasClosedModalToday = CookieManager.getCookie(this.cookieName);

    if (isModalHidden && !hasClosedModalToday) {
      ModalManager.open('#js-time-box-modal');
    }

    this.bindClose();
    this.bindVisit();
  }

  bindClose() {
    this.$context.find('.btn-default').on('click', () => {
      CookieManager.setExpirationCookie(this.cookieName, true, 1);
      this.$context.removeClass('open');

      UserTracker.emit('event', {
        eventName: 'UI Interaction',
        data: {
          context: 'renewal timebox modal',
          type: 'close',
          action: 'click'
        }
      });
    });
  }

  bindVisit() {
    this.$context.find('.btn-info').on('click', () => {
      CookieManager.setExpirationCookie(this.cookieName, true, 1);

      UserTracker.emit('event', {
        eventName: 'UI Interaction',
        data: {
          context: 'renewal timebox modal',
          type: 'link',
          action: 'click'
        }
      });
    });
  }
}

(() => {
  document.addEventListener('turbolinks:load', () => {
    new SubscriptionExpirationModal();
  });
})();
